import { 
  TOP_SIDE,
  BOTTOM_SIDE,
  COMBINED,
  STENCIL_TOP_SIDE,
  STENCIL_BOTTOM_SIDE,
  STENCIL_COMBINED,
  basicStencils 
} from "../data/StencilsConstants";

export const addStencils = (state) => {
  if (!state.stencilsType || !state.stencilsSide) return;

  const product = Spree.stencils_info.find((s) => s.slug === state.stencilsType);

  // Object.assign vs Spread make a shallow copy(only first level) so the
  // nested objects(basicStencil) are still the same reference and cause error
  // on second stencilsSide change
  let stencil = _.cloneDeep(basicStencils)
  stencil.product = product;
  state.stencils = []
  state.stencilsToBuy = []

  if (state.stencilsSide === TOP_SIDE) {
    stencil.parameters.stencil_side = STENCIL_TOP_SIDE;
    state.stencils.push(stencil);
    return
  }

  if (state.stencilsSide === BOTTOM_SIDE) {
    stencil.parameters.stencil_side = STENCIL_BOTTOM_SIDE;
    state.stencils.push(stencil);
    return;
  }

  if (state.stencilsSide === COMBINED) {
    stencil.parameters.stencil_side = STENCIL_COMBINED;
    state.stencils.push(stencil);
    return
  }

  stencil.parameters.stencil_side = STENCIL_TOP_SIDE;
  state.stencils.push(stencil);
  stencil = _.cloneDeep(stencil)
  stencil.parameters.stencil_side = STENCIL_BOTTOM_SIDE;
  state.stencils.push(stencil);
}
